<template>
  <!--<base-section-heading title="" />-->
  <div style="margin: 40px" class="jobseekars pl-3 pb-5 pt-5 pr-3">
    <i
      ><p>
        We help our clients and prospects succeed by providing an optimal venue
        for them to meet. We have a beneficial impact on both the organization
        and the individual by finding the appropriate talent for the right job.

        <br />
        <br />
        We have worked with SMEs and MNCs and we specialise in recruiting in the
        following functions: Compliance, Engineering, Finance & Accounting,
        Front Office, Human Resources, IT, Legal, Marketing, Operations, Risk,
        Sales, Supply Chain & Procurement amongst others.
        <br />
        <br />
        Our industry coverage include: Chemicals, Commodities, Energy, Financial
        Services, FMCG & Retail, Food & Nutrition, Health & Life Sciences,
        Hospitality & Real Estate, Industrial Conglomerates, IT & Telco,
        Logistics, Technology, Semiconductor and many others.
      </p></i
    >
    <div class="pt-4">
      <h3><b>For Jobseekers</b></h3>
      <p class="pt-3">
        Please email your resume to <b><a>contact@joanrecruit.com</a></b>
      </p>
    </div>
    <div class="pt-4">
      <h3><b>For Employers</b></h3>
      <p class="pt-3">
        To Upload a job Specification(s) for the position(s) you are recruiting.
        Please Complete the form below.
        <br />
        One of your specialist Consultants will contact you directly to discuss
        the role(s) in more Details.
      </p>
      <div class="pt-5">
        <v-hover>
          <v-card
            class="pt-4 pl-4 pb-4 pr-4"
            :class="`elevation-${hover ? 24 : 6}`"
            :v-slot:default="{ hover }"
          >
            <h3 class="pt-3"><b>JOB APPLICATION </b></h3>
            <v-row class="pt-5">
              <v-col cols="12" md="6">
                <form>
                  <v-text-field
                    v-model="personName"
                    label="*CONTACT PERSON'S NAME"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="companyName"
                    label="*COMPANY NAME"
                    required
                  ></v-text-field>
                </form>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="email"
                  label="*E-MAIL"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="location"
                  label="*LOCATION OF JOB"
                  required
                ></v-text-field>
              </v-col>
              <v-row>
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="4" class="pl-5">
                      <v-checkbox
                        v-model="checkbox"
                        value="Permenant"
                        label="Permenant"
                        required
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="4" class="pl-5">
                      <v-checkbox
                        v-model="checkbox"
                        label="Contract"
                        value="Contract"
                        required
                      ></v-checkbox
                    ></v-col>
                    <v-col cols="12" md="4" class="pl-5">
                      <v-checkbox
                        v-model="checkbox"
                        label="Temporary"
                        value="Temporary"
                        required
                      ></v-checkbox
                    ></v-col>
                  </v-row>
                </v-col>

                <div class="pt-5 pl-5">
                  <input
                    type="file"
                    class="pt-5"
                    id="file"
                    ref="file"
                    @change="handleFileUpload($event)"
                  />
                  <br />
                </div>
              </v-row>
            </v-row>
            <v-row class="pl-3 pr-3 pt-4">
              <v-textarea
                outlined
                name="input-7-4"
                v-model="textarea"
                height="100"
                placeholder="PLEASE TYPE THE JOB SPECIFICATION DETAILS HERE IF YOU HAVE NOT UPLOADED A JOB SPECS FILE"
              ></v-textarea>
            </v-row>

            <div class="pl-1">
              <v-btn
                class="mr-4 white--text"
                color="red accent-4"
                @click="Submit()"
              >
                <b> submit</b>
              </v-btn>
            </div>
          </v-card>
        </v-hover>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      personName: "",
      email: "",
      location: "",
      companyName: "",
      checkbox: "",
      file: [],
      textarea: "",
      files: [],
    };
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      console.log(this.file);
    },
    Submit() {
      let formData = new FormData();
      formData.append("sendFile", this.file);
      formData.append("personalName", this.personName);
      formData.append("personalEmail", this.email);
      formData.append("companyName", this.companyName);
      formData.append("location", this.location);
      formData.append("jobType", this.checkbox);
      formData.append("jobSpec", this.textarea);
      const headers = { "Content-Type": "multipart/form-data" };
      axios
        .post(
          "https://joan.maidagencysoftware.com/api/routes/post-employer-requirement.php",
          formData,

          {
            personalName: this.personName,
            personalEmail: this.email,
            companyName: this.companyName,
            location: this.location,
            jobType: this.checkbox,
            jobSpec: this.textarea,
            sendFile: this.file,
          }
        )
        .then((response) => {
          console.log(response);
          this.files = response.data.files;
        });
      this.file = "";
      this.textarea = "";
      this.checkbox = "";
      this.location = "";
      this.companyName = "";
      this.email = "";
      this.personName = "";
      this.file = "";
    },
  },
};
</script>

<style  scoped>
.jobseekars {
  text-align: justify;
}
a {
  color: red;
}
</style>
